import { render, staticRenderFns } from "./engTable.vue?vue&type=template&id=508e8baa&scoped=true&"
import script from "./engTable.vue?vue&type=script&lang=js&"
export * from "./engTable.vue?vue&type=script&lang=js&"
import style0 from "./engTable.vue?vue&type=style&index=0&id=508e8baa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508e8baa",
  null
  
)

export default component.exports